import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card shadow-sm mb-4 border-warning mt-4"
}
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table table-hover align-middle mb-0" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "badge bg-light text-dark border" }
const _hoisted_7 = { class: "text-center text-nowrap small" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "badge bg-secondary" }
const _hoisted_10 = { class: "d-flex flex-column gap-2" }
const _hoisted_11 = {
  key: 0,
  class: "text-wrap",
  style: {"max-width":"500px","white-space":"pre-wrap","font-size":"0.9em"}
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = ["disabled", "onClick"]
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MediaDisplay = _resolveComponent("MediaDisplay")!

  return (_ctx.messages && _ctx.messages.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "card-header bg-warning text-dark bg-opacity-10" }, [
          _createElementVNode("h5", { class: "mb-0" }, [
            _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }),
            _createTextVNode(" Mensajes Sin Vincular ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("thead", { class: "table-light" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "text-center" }, "# ID"),
                  _createElementVNode("th", { class: "text-center" }, "Fecha"),
                  _createElementVNode("th", { class: "text-center" }, "Tipo"),
                  _createElementVNode("th", null, "Contenido"),
                  _createElementVNode("th", { class: "text-center" }, "Acciones")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: msg.messageId
                  }, [
                    _createElementVNode("td", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(msg.messageId), 1)
                    ]),
                    _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.formatDateTime(msg.date)), 1),
                    _createElementVNode("td", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getMessageTypeLabel(msg.messageType)), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_10, [
                        (msg.text)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(msg.text.substring(0, 200) +
                      (msg.text.length > 200 ? "..." : "")), 1))
                          : _createCommentVNode("", true),
                        (msg.mediaType && msg.mediaType !== 'none')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(_component_MediaDisplay, {
                                "media-type": msg.mediaType || 'none',
                                "storage-path": msg.storagePath,
                                style: {"max-width":"200px"}
                              }, null, 8, ["media-type", "storage-path"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      (_ctx.canReanalyzeAlerts)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-sm btn-outline-primary",
                            disabled: _ctx.isReprocessing[msg.messageId],
                            onClick: ($event: any) => (_ctx.$emit('reprocess', msg))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["fas fa-robot me-1", {
                      'fa-spin': _ctx.isReprocessing[msg.messageId],
                    }])
                            }, null, 2),
                            _cache[0] || (_cache[0] = _createTextVNode(" Reprocesar ", -1))
                          ], 8, _hoisted_14))
                        : _createCommentVNode("", true),
                      (_ctx.canLinkMessages)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-sm btn-outline-secondary ms-1",
                            onClick: ($event: any) => (_ctx.$emit('open-link-modal', msg))
                          }, [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("i", { class: "fas fa-link me-1" }, null, -1),
                            _createTextVNode(" Vincular ", -1)
                          ]))], 8, _hoisted_15))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}